const getCountry = function() {
   return new Promise((resolve, reject) => {
      try {
         fetch(`https://ipinfo.io/json?token=${process.env.VUE_APP_INFO_TOKEN}`)
            .then(async (res) => {
               const data = await res.json();
               if (res.status === 200) resolve(data && data.country);
               else reject(data);
            })
            .catch((err) => {
               reject(err);
            });
      } catch (e) {
         reject(e);
      }
   });
};

export default getCountry;
